import { useId } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProjectName } from 'core/userContext';
import { PrimaryButton } from 'ui/button';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES } from 'ui/modal';
import { AuthedEmailCreateForm } from './AuthedEmailCreateForm';
import {
  SenderCreateFormProvider,
  SenderCreateFormContextType,
} from '../contexts/SenderCreateFormProvider';
import { createSenderRequest } from '../actions';
import { getValidSendDomains } from '../selectors';
import type { AuthedEmailCreateModalProps } from '../types';

export const AuthedEmailCreateModal = ({ onClose }: AuthedEmailCreateModalProps) => {
  const dispatch = useDispatch();
  const validSendDomains = useSelector(getValidSendDomains);
  const projectName = useSelector(selectUserProjectName);

  const id = useId();
  const formId = useId();

  const onSubmit = (data: SenderCreateFormContextType) => {
    dispatch(createSenderRequest(data));
    onClose();
  };

  return (
    <SenderCreateFormProvider validSendDomains={validSendDomains}>
      <Modal size={MODAL_SIZES.SMALL} onClose={onClose} isModalOpen id={id}>
        <ModalHeader>Add a new sender to {projectName}</ModalHeader>
        <ModalBody>
          <AuthedEmailCreateForm formId={formId} onSubmit={onSubmit} />
        </ModalBody>
        <ModalFooter onClose={onClose}>
          <PrimaryButton data-test="senders-create-new-sender-action" form={formId}>
            Confirm
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    </SenderCreateFormProvider>
  );
};
